var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.proxyData.arResult.ITEMS
      ? _c(
          "div",
          { staticClass: "carousel" },
          [
            _vm.proxyData.arResult.ITEMS.length > 5
              ? _c("div", { staticClass: "nav-swiper" }, [
                  _c(
                    "div",
                    {
                      staticClass: "left-arrow swiper-button-prev",
                      on: { click: _vm.prevSwiper },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "11",
                            height: "20",
                            viewBox: "0 0 11 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z",
                              fill: "currentColor",
                              "transform-origin": "center",
                              transform: "rotate(180)",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "right-arrow swiper-button-next",
                      on: { click: _vm.nextSwiper },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "11",
                            height: "20",
                            viewBox: "0 0 11 20",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z",
                              fill: "currentColor",
                              "transform-origin": "center",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "swiper-container",
              {
                ref: "swiper",
                staticClass: "carousel-container",
                class: { "one-line": _vm.proxyData.columnElements == 1 },
                style: {
                  height: 420 * _vm.proxyData.columnElements + 40 + "px",
                },
                attrs: {
                  "slides-per-view": 5,
                  pagination: false,
                  "space-between": "15",
                  "grid-rows": _vm.proxyData.columnElements,
                },
              },
              _vm._l(_vm.proxyData.arResult.ITEMS, function (item) {
                return _c(
                  "swiper-slide",
                  {
                    key: item.ID,
                    staticClass: "product-element",
                    style: {
                      height:
                        "calc((100% - 100px) /" +
                        _vm.proxyData.columnElements +
                        ")",
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "shops-bor-cart" },
                      [_c("listing-card", { attrs: { item: item } })],
                      1
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xl-12" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "loader",
          },
          [
            _c("img", {
              attrs: {
                src: _vm.proxyData.siteTemplatePath + "/images/loader.gif",
                alt: "",
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }